/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Person } from './Person';
import {
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
} from './Person';
import type { Player } from './Player';
import {
    PlayerFromJSON,
    PlayerFromJSONTyped,
    PlayerToJSON,
} from './Player';

/**
 * 
 * @export
 * @interface TeamRegistrationRequest
 */
export interface TeamRegistrationRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    teamName: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    clubName: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    gender: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    primaryColor: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    homeColor: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    awayColor: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationRequest
     */
    goalkeeperColor: string;
    /**
     * 
     * @type {Array<Player>}
     * @memberof TeamRegistrationRequest
     */
    players: Array<Player>;
    /**
     * 
     * @type {Array<Person>}
     * @memberof TeamRegistrationRequest
     */
    officials: Array<Person>;
    /**
     * 
     * @type {Person}
     * @memberof TeamRegistrationRequest
     */
    creator: Person;
}

/**
 * Check if a given object implements the TeamRegistrationRequest interface.
 */
export function instanceOfTeamRegistrationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "teamName" in value;
    isInstance = isInstance && "clubName" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "gender" in value;
    isInstance = isInstance && "primaryColor" in value;
    isInstance = isInstance && "homeColor" in value;
    isInstance = isInstance && "awayColor" in value;
    isInstance = isInstance && "goalkeeperColor" in value;
    isInstance = isInstance && "players" in value;
    isInstance = isInstance && "officials" in value;
    isInstance = isInstance && "creator" in value;

    return isInstance;
}

export function TeamRegistrationRequestFromJSON(json: any): TeamRegistrationRequest {
    return TeamRegistrationRequestFromJSONTyped(json, false);
}

export function TeamRegistrationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamRegistrationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teamName': json['teamName'],
        'clubName': json['clubName'],
        'country': json['country'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'category': json['category'],
        'gender': json['gender'],
        'primaryColor': json['primaryColor'],
        'homeColor': json['homeColor'],
        'awayColor': json['awayColor'],
        'goalkeeperColor': json['goalkeeperColor'],
        'players': ((json['players'] as Array<any>).map(PlayerFromJSON)),
        'officials': ((json['officials'] as Array<any>).map(PersonFromJSON)),
        'creator': PersonFromJSON(json['creator']),
    };
}

export function TeamRegistrationRequestToJSON(value?: TeamRegistrationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teamName': value.teamName,
        'clubName': value.clubName,
        'country': value.country,
        'state': value.state,
        'city': value.city,
        'category': value.category,
        'gender': value.gender,
        'primaryColor': value.primaryColor,
        'homeColor': value.homeColor,
        'awayColor': value.awayColor,
        'goalkeeperColor': value.goalkeeperColor,
        'players': ((value.players as Array<any>).map(PlayerToJSON)),
        'officials': ((value.officials as Array<any>).map(PersonToJSON)),
        'creator': PersonToJSON(value.creator),
    };
}

